import React from 'react'
import { Text } from './styled'

const Title = ({ text }) => <Text>{text}</Text>

export default Title
